/**
 * Modal.js
 */

import $ from 'jquery';
import Cookie from 'js-cookie';

class Modal {

    constructor() {

        if (Cookie.get('subscribed') === 'true' || Cookie.get('visited') === 'true' || $('[data-display]').data('display') == 'hide' ) {

            return;

        }
        else {

            setTimeout(

                function () {

                    $('.donation-modal').addClass('active');
                    $('body').addClass('locked');

                }

                , 2000);

        }

        this.closePopUp();

    }

    closePopUp() {

        $('.modal-close').on('click', function () {

            // Set cookie conditional.
            // If already visited set to expire 30 days
            if (Cookie.get('visited') != true) {

                Cookie.set('visited', true, {
                    expires: 3
                });

            }

            $('.donation-modal').removeClass('active');
            $('body').removeClass('locked');

        })

        $('.close-pop-up').on('click', function () {

            // Set cookie conditional.
            // If already visited set to expire 30 days
            if (Cookie.get('visited') != true) {
                Cookie.set('visited', true, { expires: 3 });
            }

            $('.pop-up-container').removeClass('show');
            $('body').removeClass('locked');

        });

    }

}

new Modal();